import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import SingleUnitShare from '../../../SingleUnit/components/Share/index';
import SingleBuildingShare from '../../../SingleBuilding/components/Share/index';

import {
  buildingFL,
  propertyFL
} from '../../../../shared/helpers/utils';
import { _axiosCall } from '../../../../shared/helpers/apicalls';

const apiURL = process.env.API_ROOT + '/query/';

export default function DetailModal({ shareModal, shareKey, toggleModal }) {
  const [shareModalData, setShareModalData] = useState(null);
  const [shareType, setShareType] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
	if (shareModal && shareKey) {
	  fetchDetailData(shareKey);
	}
  }, [shareModal, shareKey]);

  const fetchDetailData = async (key) => {
	if (!key) return;

	setLoading(true);

	let type = null;
	let axiosData = null;

	if (key.charAt(0) == "b") {
	  type = "building";
	  axiosData = {
		url: apiURL + "/we3-buildings?cache=60",
		method: "post",
		query: {
		  q: "key:(" + key + ")",
		  fq: ["deleted:false"],
		  fl: buildingFL,
		  wt: "json",
		  rows: 1
		}
	  };
	} else if (key.charAt(0) == "p") {
	  type = "unit";
	  axiosData = {
		url: apiURL + "/we3-properties?cache=60",
		method: "post",
		query: {
		  q: "key:(" + key + ")",
		  fq: ["deleted:false"],
		  fl: propertyFL,
		  wt: "json",
		  rows: 1
		}
	  };
	} else {
	  console.error("Unknown key type:", key);
	  setLoading(false);
	  return;
	}

	try {
	  const res = await _axiosCall(axiosData);

	  if (res && res.docs && res.docs.length > 0) {
		let item = res.docs[0];
		let modalShareData = {};

		if (type == "unit" && item.building) {
		  // Fetch related building
		  const buildingData = {
			url: apiURL + "/we3-buildings?cache=60",
			method: "post",
			query: {
			  q: "key:(" + item.building + ")",
			  fq: ["deleted:false"],
			  fl: buildingFL,
			  wt: "json",
			  rows: 1
			}
		  };

		  const buildingRes = await _axiosCall(buildingData);

		  if (buildingRes && buildingRes.docs && buildingRes.docs.length > 0) {
			item.building = buildingRes.docs[0];
		  }
		}
		
		// 🔥 Build modalShareData correctly
		if (type == "building") {
		  modalShareData['building_key'] = item.key;
		  modalShareData['building'] = item;
		} else if (type == "unit") {
		  modalShareData['building_key'] = item.building.key || item.building; // fallback if not populated
		  modalShareData['property_key'] = item.key;
		  modalShareData['property'] = item;
		}

		setShareModalData(modalShareData);
		setShareType(type);
	  } else {
		setShareModalData(null);
		console.warn("No data found for key:", key);
	  }
	} catch (error) {
	  console.error("Failed fetching detail data", error);
	  setShareModalData(null);
	} finally {
	  setLoading(false);
	}
  };

  return (
	<Modal
	  isOpen={shareModal}
	  toggle={toggleModal}
	  modalClassName="ltr-support"
	  className="modal-dialog contact__modal"
	>
	  <div className="modal__header">
		<button
		  className="lnr lnr-cross modal__close-btn"
		  type="button"
		  onClick={toggleModal}
		/>
	  </div>
	  <div className="modal__body">
		{loading ? (
		  <div>Loading...</div>
		) : shareType === "building" ? (
		  <SingleBuildingShare sharePageData={shareModalData} isModal />
		) : shareType === "unit" ? (
		  <SingleUnitShare sharePageData={shareModalData} isModal />
		) : (
		  <div>No data available</div>
		)}
	  </div>
	</Modal>
  );
}
